import React from "react";
import { Rating } from "@mui/material";
import styled from "styled-components";
import { green } from "../constants/colors";

// Define the custom container for each star
const StarContainer = styled.div`
  background-color: ${green};
  color: white;
  display: inline-flex;
  padding: 1px;
  //   border-radius: 5px;
`;

const CustomIconContainer = (props) => {
  const { value, ...other } = props;
  return <StarContainer {...other} />;
};

const CustomRating = ({ google, feedback }) => {
  return (
    <Rating
      name="customized-rating"
      defaultValue={5}
      IconContainerComponent={google ? "" : CustomIconContainer}
      sx={{
        color: !google ? "white" : "#de9b16",
        gap: "1px",
        fontSize: feedback ? "22px" : "16px",
      }} // This will set the color of the stars to white
    />
  );
};

export default CustomRating;
